import type { DecoratedFileCollection } from '@witmetrics/utils';

export const classes = {
  icon: 'cursor-pointer text-2xl',
  auroraIcon:
    'size-10 shrink-0 place-center cursor-pointer rounded-xl bg-brand-accent/[0.12] text-brand-accent',
  auroraFolderIcon: 'size-[21px]',
  spinner: 'cursor-progress size-[24px]',
  subCollection: 'pl-6 pr-0',
  subCollectionList: 'mb-0',
  card: 'place-start p-3 my-0.5 bg-white dark:bg-[#332e43] text-grey-8 dark:text-mauve-1 cursor-pointer rounded-xl border-2 border-transparent hover:shadow-md transition-all duration-150',
  auroraCard:
    'place-start p-3 my-0.5 cursor-pointer rounded-xl border-2 border-transparent transition-colors hover:bg-black/[0.05] dark:hover:bg-white/[0.06]',
  auroraActive:
    'border-brand-accent/70 bg-brand-accent/[0.08] hover:bg-brand-accent/[0.08]',
  auroraCardTitle:
    'text-sm font-medium text-taupe-3 cursor-pointer dark:text-mauve-1',
  cardDense: 'p-1.5',
  active: 'border-orange-3 hover:border-orange-3',
  content: 'place-start gap-4 min-w-0 w-full',
  contentDense: 'gap-2',
  folderIcon: 'text-grey-6 dark:text-mauve-3 text-xl shrink-0',
  auroraFolderTint: 'text-brand-accent dark:text-brand-accent-dark',
  titleWrapper: 'grow',
  title: 'text-sm font-medium text-grey-8 dark:text-mauve-1 cursor-pointer',
  optionsWrapper: 'place-center shrink-0',
  optionsIcon: 'options-icon cursor-pointer text-taupe-2 dark:text-mauve-2',
  optionsIconOpen: '!w-6',
};

export const styles = {
  card: {
    '& .options-icon': {
      width: 0,
      transition: 'width 0.2s',
    },
    '&:hover .options-icon': {
      width: 24,
    },
  },
};

export function getCountLabel(fileCollection: DecoratedFileCollection) {
  const count = fileCollection.childFileCollections + fileCollection.childFiles;
  if (count === 0) return 'No items';
  if (count === 1) return '1 item';
  return `${count} items`;
}
